import { ListFilterTicketParam } from '../models/Ticket'
import { TicketRepository } from '../repositories/TicketRepository'

export function ListFilterTicketCase(ticketRepository: TicketRepository) {
  return async function (data: ListFilterTicketParam) {
    return await ticketRepository.listFilterTicket({ data })
  }
}
